import { useNavigate } from "react-router-dom";
import {
  globalConstants,
  loginConstants,
  globalSystemConstants,
  eventConstants,
  translationConstants,
  contentType,
  roles,
} from "../../constants";
import { ToastifyService, eventService } from "../../services";
import { custom, failure, success } from "./utilities";
import i18next from "i18next";
import { UserActions } from "./user.actions";
import { downloadBase64File, getUserPayload } from "../../system";
import { authActions } from "./auth.action";

const {
  ADMIN_EVENT_LIST,
  ALL_EVENT,
  ADD_EVENT,
  VIEW_MODAL,
  DELETE_EVENT,
  EVENT_DATA_BY_ID,
  EVENT_DATA_BY_ID_WITH_DOCS,
  UPDATE_EVENT,
  ADMIN_EVENT_PARTICIPANTS_LIST,
  SEARCH_PARTICIPANTS,
  ADD_EVENT_PARTICIPANTS,
  LIST_PUBLIC_EVENTS,
  MY_EVENTS_LIST,
  VALIDATE_PARTICIPANTS,
  VALIDATE_PARTICIPANTS_TOFALSE,
  RESET_PARTICIPANT_DETAILS,
  DOWNLOAD_PARTICIPANT_DETAILS,
  CANCEL_PUBLIC_EVENT_REGISTRATION,
  CANCEL_PUBLIC_EVENT_REGISTRATION_BY_ADMIN,
  CANCEL_PRIVATE_EVENT_REGISTRATION,
  RESET_EVENT_DATA_BY_ID,
  EVENT_TOTAL_PAYMENT_BY_ID_DATA,
} = eventConstants;

const gridData = {
  length: 10,
  pageNumber: 1,
  orderBy: "EventInfo.Id desc",
  filterQuery: "",
  search: "",
};

const getPaginatedEvents = (params) => {
  return (dispatch) => {
    dispatch(custom(ADMIN_EVENT_LIST, globalSystemConstants.SPINNER_ACTIVATE));

    eventService
      .getPaginatedEvents(params)
      .then((response) => {
        dispatch(success(response, ADMIN_EVENT_LIST));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(ADMIN_EVENT_LIST, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const getPaginatedPublicEvents = (params) => {
  return (dispatch) => {
    eventService
      .getPaginatedPublicEvents(params)
      .then((response) => {
        dispatch(success(response, LIST_PUBLIC_EVENTS));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      });
  };
};

const getPaginatedMyEvents = (params, userId) => {
  return (dispatch) => {
    dispatch(custom(MY_EVENTS_LIST, globalSystemConstants.SPINNER_ACTIVATE));

    eventService
      .getPaginatedMyEvents(params, userId)
      .then((response) => {
        dispatch(success(response, MY_EVENTS_LIST));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(MY_EVENTS_LIST, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const getPaginatedEventsParticipants = (params, eventId) => {
  return (dispatch) => {
    dispatch(
      custom(
        ADMIN_EVENT_PARTICIPANTS_LIST,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );

    eventService
      .getPaginatedEventParticipants(params, eventId)
      .then((response) => {
        dispatch(success(response, ADMIN_EVENT_PARTICIPANTS_LIST));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            ADMIN_EVENT_PARTICIPANTS_LIST,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

// actions.js
export const addEvent = (eventData, gridState, onSuccess) => {
  return (dispatch) => {
    dispatch(custom(ADD_EVENT, globalSystemConstants.SPINNER_ACTIVATE));
    eventService
      .addEvent(eventData)
      .then((response) => {
        if (response) {
          dispatch(getPaginatedEvents(gridState));
          ToastifyService.showSuccess(
            i18next.t(translationConstants.DONE_SUCCESSFULLY)
          );
          if (onSuccess) {
            onSuccess(); // Execute the callback function
          }
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(custom(ADD_EVENT, globalSystemConstants.SPINNER_DEACTIVATE));
      });
  };
};

const toggleViewModal = (flag) => {
  return (dispatch) => dispatch(success(flag, VIEW_MODAL));
};

const getEventById = (id, onSuccess) => {
  return (dispatch) => {
    dispatch(custom(EVENT_DATA_BY_ID, globalSystemConstants.SPINNER_ACTIVATE));

    eventService
      .getEventById(id)
      .then((response) => {
        dispatch(success(response, EVENT_DATA_BY_ID));
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(EVENT_DATA_BY_ID, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const resetGetEventById = () => {
  return (dispatch) => {
    dispatch(custom(" ", RESET_EVENT_DATA_BY_ID));
  };
};

const getParticipantByEmail = (email) => {
  return (dispatch) => {
    dispatch(
      custom(SEARCH_PARTICIPANTS, globalSystemConstants.SPINNER_ACTIVATE)
    );

    eventService
      .getParticipantByEmail(email)
      .then((response) => {
        dispatch(success(response, SEARCH_PARTICIPANTS));
      })
      .catch((error) => {
        ToastifyService.showError(error);
        dispatch(failure(null, SEARCH_PARTICIPANTS));
      })
      .finally(() => {
        dispatch(
          custom(SEARCH_PARTICIPANTS, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const getEventByIdWithDocs = (id) => {
  return (dispatch) => {
    dispatch(
      custom(EVENT_DATA_BY_ID_WITH_DOCS, globalSystemConstants.SPINNER_ACTIVATE)
    );

    eventService
      .getEventByIdWithDocs(id)
      .then((response) => {
        dispatch(success(response, EVENT_DATA_BY_ID_WITH_DOCS));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            EVENT_DATA_BY_ID_WITH_DOCS,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const updateEvent = (data, gridState, onSuccess) => {
  return (dispatch) => {
    dispatch(custom(UPDATE_EVENT, globalSystemConstants.SPINNER_ACTIVATE));

    eventService
      .updateEvent(data)
      .then((response) => {
        ToastifyService.showSuccess(i18next.t(response));
        dispatch(getPaginatedEvents(gridState));
        if (onSuccess) {
          onSuccess(); // Execute the callback function
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(UPDATE_EVENT, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const updateEventStatusById = (id, status, gridState, onSuccess) => {
  return (dispatch) => {
    dispatch(custom(UPDATE_EVENT, globalSystemConstants.SPINNER_ACTIVATE));
    eventService
      .updateEventStatusById(id, status)
      .then((response) => {
        ToastifyService.showSuccess(response);
        if (response) {
          dispatch(getPaginatedEvents(gridState));
          if (onSuccess) {
            onSuccess(); // Execute the callback function
          }
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(UPDATE_EVENT, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const resetParticipantDetails = () => {
  return (dispatch) => {
    dispatch(success("", RESET_PARTICIPANT_DETAILS));
  };
};

const addEventParticipant = (
  data,
  gridState,
  setShow,
  eventId,
  callType,
  onSuccess
) => {
  return (dispatch) => {
    dispatch(
      custom(ADD_EVENT_PARTICIPANTS, globalSystemConstants.SPINNER_ACTIVATE)
    );

    eventService
      .addEventParticipant(data)
      .then((message) => {
        ToastifyService.showSuccess(i18next.t(message));
        dispatch(UserActions.OpenModal(false));
        if (callType === "adminPage") {
          dispatch(getPaginatedEventsParticipants(gridState, eventId));
        }
        if (onSuccess) {
          onSuccess();
        }
        // dispatch(getPaginatedEventsParticipants(gridState, eventId));
        // dispatch(getCenterInstructors(centerId, gridState));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        setShow(false);
        dispatch(
          custom(
            ADD_EVENT_PARTICIPANTS,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const addParticipantWithPayment = (checkoutId, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(ADD_EVENT_PARTICIPANTS, globalSystemConstants.SPINNER_ACTIVATE)
    );

    eventService
      .addParticipantWithPayment(checkoutId)
      .then((message) => {
        ToastifyService.showSuccess(i18next.t(message));
        dispatch(UserActions.OpenModal(false));
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            ADD_EVENT_PARTICIPANTS,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const deleteEventById = (eventId) => {
  return (dispatch) => {
    dispatch(custom(DELETE_EVENT, globalSystemConstants.SPINNER_ACTIVATE));
    eventService
      .deleteEventById(eventId)
      .then((response) => {
        if (response) {
          dispatch(getPaginatedEvents(gridData));
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(DELETE_EVENT, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const exportParticipantData = (gridState, requestType, eventId) => {
  return (dispatch) => {
    dispatch(
      custom(
        DOWNLOAD_PARTICIPANT_DETAILS,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    eventService
      .exportParticipantData(gridState, requestType, eventId)
      .then((response) => {
        downloadBase64File(
          response.content,
          contentType.CSV,
          response.fileName
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            DOWNLOAD_PARTICIPANT_DETAILS,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const cancelPublicEventRegistration = (
  userId,
  gridState,
  eventId,
  onSuccess
) => {
  return (dispatch) => {
    dispatch(
      custom(
        CANCEL_PUBLIC_EVENT_REGISTRATION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    eventService
      .cancelPublicEventRegistration(userId, eventId)
      .then((response) => {
        ToastifyService.showSuccess(response);
        dispatch(getPaginatedMyEvents(gridState, userId));
        dispatch(EventActions.getEventById(eventId));
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            CANCEL_PUBLIC_EVENT_REGISTRATION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
const cancelPrivateEventRegistration = (
  userId,
  gridState,
  eventId,
  callFrom,
  onSuccess
) => {
  return (dispatch) => {
    dispatch(
      custom(
        CANCEL_PRIVATE_EVENT_REGISTRATION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    eventService
      .cancelPrivateEventRegistration(userId, eventId)
      .then((response) => {
        ToastifyService.showSuccess(response);
        dispatch(EventActions.toggleViewModal(false));
        dispatch(getPaginatedEventsParticipants(gridState, eventId));
        if (callFrom === "MyEventPage") {
          dispatch(getPaginatedMyEvents(gridState, userId));
        }
        dispatch(EventActions.getEventById(eventId));
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            CANCEL_PRIVATE_EVENT_REGISTRATION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const cancelPublicEventRegistrationByAdmin = (
  data,
  onSuccess,
  gridState,
  eventId
) => {
  return (dispatch) => {
    dispatch(
      custom(
        CANCEL_PUBLIC_EVENT_REGISTRATION_BY_ADMIN,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    eventService
      .cancelPublicEventRegistrationByAdmin(data)
      .then((response) => {
        ToastifyService.showSuccess(response);
        if (onSuccess) {
          onSuccess();
        }
        dispatch(getPaginatedEventsParticipants(gridState, eventId));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            CANCEL_PUBLIC_EVENT_REGISTRATION_BY_ADMIN,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const validateParticipentsForEvents = (
  systemUserId,
  eventId,
  setSelectEvent
) => {
  return (dispatch) => {
    dispatch(
      custom(VALIDATE_PARTICIPANTS, globalSystemConstants.SPINNER_ACTIVATE)
    );
    eventService
      .validateParticipentsForEvents(systemUserId, eventId)
      .then((response) => {
        dispatch(
          authActions.setIsMemberStatusInLoginReducer(
            response.payload.isMembershipHolder
          )
        );
        dispatch(success(response, VALIDATE_PARTICIPANTS));
        ToastifyService.showSuccess(response.message);
      })
      .catch((error) => {
        const userData = getUserPayload();
        if (
          userData?.user?.role === roles.Center ||
          userData?.user?.role === roles.Admin ||
          userData?.user?.role === roles.SuperAdmin
        ) {
          ToastifyService.showError(translationConstants.INVALID_USER);
        } else {
          ToastifyService.showError(error);
        }
        setSelectEvent(null);
        // dispatch(failure(null, VALIDATE_PARTICIPANTS));
      })
      .finally(() => {
        dispatch(
          custom(
            VALIDATE_PARTICIPANTS,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const setValidateParticipantsFalse = () => {
  return (dispatch) => {
    dispatch(custom(null, VALIDATE_PARTICIPANTS_TOFALSE));
  };
};

const eventRegistrationwithSavedCard = (data, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    eventService
      .eventRegistrationwithSavedCard(data)
      .then((response) => {
        ToastifyService.showSuccess(response);
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const getEventTotalPaymentById = (eventId) => {
  return (dispatch) => {
    eventService
      .getEventTotalPaymentById(eventId)
      .then((response) =>
        dispatch(success(response, EVENT_TOTAL_PAYMENT_BY_ID_DATA))
      )
      .catch((error) => ToastifyService.showError(error));
  };
};

export const EventActions = {
  getPaginatedEvents,
  addEvent,
  toggleViewModal,
  deleteEventById,
  getEventById,
  getEventByIdWithDocs,
  updateEvent,
  getPaginatedEventsParticipants,
  getParticipantByEmail,
  addEventParticipant,
  exportParticipantData,
  getPaginatedPublicEvents,
  getPaginatedMyEvents,
  cancelPublicEventRegistration,
  cancelPrivateEventRegistration,
  cancelPublicEventRegistrationByAdmin,
  validateParticipentsForEvents,
  setValidateParticipantsFalse,
  resetParticipantDetails,
  resetGetEventById,
  updateEventStatusById,
  addParticipantWithPayment,
  eventRegistrationwithSavedCard,
  getEventTotalPaymentById,
};
